import types from './types';

const fetchMatchupInitiated = () => ({
  type: types.FETCH_MATCHUP_INITIATED,
});

const fetchMatchupSucceeded = payload => ({
  payload,
  type: types.FETCH_MATCHUP_SUCCEEDED,
});

const fetchMatchupFailed = error => ({
  payload: error,
  type: types.FETCH_MATCHUP_FAILED,
});

export default {
  fetchMatchupInitiated,
  fetchMatchupSucceeded,
  fetchMatchupFailed,
};
